export const GLOBAL_STATE = 'JobPosition'

export const JOB_POSITION_LIST = 'JOB_POSITION_LIST' as const
export const JOB_POSITION_ALL = 'JOB_POSITION_ALL' as const
export const JOB_POSITION_CREATE = 'JOB_POSITION_CREATE' as const
export const JOB_POSITION_DELETE = 'JOB_POSITION_DELETE' as const
export const JOB_POSITION = 'JOB_POSITION' as const
export const JOB_POSITION_ACTIVATE = 'JOB_POSITION_ACTIVATE' as const
